// Player colours (backend Player::VALID_COLORS) grouped into colour names a screen reader can say.
const colorNames = {
  "#1854c2": "blue",
  "#8181ff": "purple",
  "#f76900": "orange",
  "#8e5145": "brown",
  "#fda50f": "yellow",
  "#f9a602": "yellow",
  "#2e8b57": "green",
  "#3f704d": "green",
  "#009871": "green",
  "#0e4c92": "blue",
  "#011b33": "dark-blue",
  "#003151": "dark-blue",
  "#b8569b": "purple",
  "#d83176": "pink",
  "#63478f": "purple",
  "#622b48": "purple",
  "#aed231": "light-green",
  "#a14a4e": "brown",
  "#ca8225": "brown",
  "#ff347b": "pink",
};

// Text alternative for a PlayerAvatar that is the only cue to who the player is,
// e.g. "Avatar: cat, colour: blue".
export const getPlayerAvatarLabel = (t, player) => {
  const animal = t(`components:player-avatar.animals.${player.avatar}`, {
    defaultValue: t("components:player-avatar.animals.unknown"),
  });
  const colorName = colorNames[(player.color || "").toLowerCase()];

  if (!colorName) {
    return t("components:player-avatar.label", { animal });
  }

  return t("components:player-avatar.label-with-color", {
    animal,
    color: t(`components:player-avatar.colors.${colorName}`),
  });
};
